"use client";

import { c as _c } from "react/compiler-runtime";
import CrossIcon from "@/Components/Common/Icons/CrossIcon";
import { requestStatusKey, useGetRequestStatusesQuery, useSubmitProductRequestMutation } from "@/Redux/apis/repConnectionRequests";
import { ALPHAMD_SENDER_ID } from "@/services/alphaMdMessages";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { FiCheck, FiUsers } from "react-icons/fi";
const firstValue = value => Array.isArray(value) ? value[0] : value;
const AlphaMdRepRequestPopup = t0 => {
  const $ = _c(61);
  const {
    product,
    onClose,
    sourceSurface: t1
  } = t0;
  const sourceSurface = t1 === undefined ? "product_detail" : t1;
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submittedRequest, setSubmittedRequest] = useState(null);
  const productId = product?.id || product?._id;
  const [submitProductRequest, t2] = useSubmitProductRequestMutation();
  const {
    isLoading: isSubmitting
  } = t2;
  let t3;
  if ($[0] !== productId) {
    t3 = {
      targets: productId ? [{
        targetType: "approved",
        targetId: productId
      }] : []
    };
    $[0] = productId;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = !productId;
  let t5;
  if ($[2] !== t4) {
    t5 = {
      skip: t4,
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const {
    data: requestStatuses,
    isFetching,
    isLoading,
    isError,
    refetch
  } = useGetRequestStatusesQuery(t3, t5);
  let t6;
  if ($[4] !== productId || $[5] !== requestStatuses?.statuses) {
    t6 = requestStatuses?.statuses?.[requestStatusKey("approved", productId)];
    $[4] = productId;
    $[5] = requestStatuses?.statuses;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const savedRequest = t6;
  const existingState = savedRequest?.status ? savedRequest.state : "available";
  const states = [existingState, submittedRequest?.data?.state];
  const requestState = states.includes("connected") ? "connected" : states.includes("contacting") ? "contacting" : submittedRequest?.data?.state || existingState;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["requested", "contacting", "connected", "awaiting_signup", "alphamd_active"];
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const hasRequest = t7.includes(requestState);
  const connection = submittedRequest?.data || savedRequest;
  const statusError = !productId ? "We could not identify this product. Please refresh and try again." : isError ? "We could not check your existing request. Please retry before sending a request." : "";
  const checkingStatus = isLoading || isFetching;
  let t8;
  if ($[8] !== product?.openfda?.brand_name || $[9] !== product?.productName || $[10] !== product?.trade_name) {
    t8 = firstValue(product?.openfda?.brand_name) || product?.productName || product?.trade_name || "this product";
    $[8] = product?.openfda?.brand_name;
    $[9] = product?.productName;
    $[10] = product?.trade_name;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const productName = t8;
  let t9;
  if ($[12] !== product?.manufacturer || $[13] !== product?.openfda?.manufacturer_name) {
    t9 = firstValue(product?.openfda?.manufacturer_name) || product?.manufacturer || "Manufacturer to be confirmed";
    $[12] = product?.manufacturer;
    $[13] = product?.openfda?.manufacturer_name;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const manufacturer = t9;
  let t10;
  let t11;
  if ($[15] !== isSubmitting || $[16] !== onClose) {
    t10 = () => {
      const onKeyDown = event => {
        if (event.key === "Escape" && !isSubmitting) {
          onClose();
        }
      };
      document.addEventListener("keydown", onKeyDown);
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.removeEventListener("keydown", onKeyDown);
        document.body.style.overflow = previousOverflow;
      };
    };
    t11 = [isSubmitting, onClose];
    $[15] = isSubmitting;
    $[16] = onClose;
    $[17] = t10;
    $[18] = t11;
  } else {
    t10 = $[17];
    t11 = $[18];
  }
  useEffect(t10, t11);
  let t12;
  if ($[19] !== checkingStatus || $[20] !== hasRequest || $[21] !== isSubmitting || $[22] !== message || $[23] !== productId || $[24] !== sourceSurface || $[25] !== statusError || $[26] !== submitProductRequest) {
    t12 = async event_0 => {
      event_0.preventDefault();
      if (isSubmitting || checkingStatus || statusError || hasRequest) {
        return;
      }
      setError("");
      ;
      try {
        const response = await submitProductRequest({
          targetType: "approved",
          targetId: productId,
          requestKind: "information",
          sourceSurface,
          preferredContact: "either",
          message: message.trim()
        }).unwrap();
        setSubmittedRequest(response);
      } catch (t13) {
        const requestError = t13;
        const status = requestError?.status || requestError?.originalStatus;
        setError(status === 401 ? "Please sign in again before requesting a representative." : requestError?.data?.message || "We could not submit your request. Please try again.");
      }
    };
    $[19] = checkingStatus;
    $[20] = hasRequest;
    $[21] = isSubmitting;
    $[22] = message;
    $[23] = productId;
    $[24] = sourceSurface;
    $[25] = statusError;
    $[26] = submitProductRequest;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const submitRequest = t12;
  if (typeof document === "undefined") {
    return null;
  }
  let t13;
  if ($[28] !== isSubmitting || $[29] !== onClose) {
    t13 = event_1 => {
      if (event_1.target === event_1.currentTarget && !isSubmitting) {
        onClose();
      }
    };
    $[28] = isSubmitting;
    $[29] = onClose;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <CrossIcon fill="white" />;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== isSubmitting || $[33] !== onClose) {
    t15 = <button type="button" aria-label="Close" onClick={onClose} disabled={isSubmitting} className="absolute right-5 top-5 rounded-full p-1 disabled:opacity-50">{t14}</button>;
    $[32] = isSubmitting;
    $[33] = onClose;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="flex items-center gap-4 pr-10 text-white"><div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-white shadow-lg"><Image src="/Images/alphamd-half-logo.png" alt="Alpha.MD" width={46} height={46} className="h-11 w-11 object-contain" /></div><div><p className="text-xs font-medium uppercase tracking-[0.14em] text-white/80">Alpha.MD concierge</p><h2 className="mt-1 text-xl font-semibold sm:text-2xl">Connect with a product representative</h2></div></div>;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15) {
    t17 = <div className="reps-profile-bg reps-bg-image relative flex min-h-[116px] items-center rounded-t-2xl px-6 sm:px-8">{t15}{t16}</div>;
    $[36] = t15;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== checkingStatus || $[39] !== connection || $[40] !== error || $[41] !== hasRequest || $[42] !== isError || $[43] !== isSubmitting || $[44] !== manufacturer || $[45] !== message || $[46] !== onClose || $[47] !== productId || $[48] !== productName || $[49] !== refetch || $[50] !== requestState || $[51] !== statusError || $[52] !== submitRequest || $[53] !== submittedRequest) {
    t18 = hasRequest ? <div className="flex flex-col items-center px-6 py-10 text-center sm:px-10"><div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#EAF8EF] text-[#169B4A]"><FiCheck size={34} /></div><h3 className="mt-5 text-xl font-semibold text-[#252525]">{requestState === "alphamd_active" ? "Alpha.MD is handling your request" : requestState === "awaiting_signup" ? "Waiting for representative signup" : requestState === "connected" ? "Representative connected" : requestState === "contacting" ? "Your request is in progress" : submittedRequest && !submittedRequest.duplicate ? "Request received" : "Request already received"}</h3><p className="mt-2 max-w-[460px] text-sm leading-6 text-[#6B6B6B]">{requestState === "connected" ? `Your representative is connected for ${productName}. Open Messages to continue the conversation.` : requestState === "alphamd_active" ? `The Alpha.MD team is handling your ${productName} request. Reply in Messages to continue.` : requestState === "awaiting_signup" ? "The invited representative will connect after verified signup and full setup." : `Our team is coordinating your ${productName} representative request.`}</p>{["connected", "alphamd_active"].includes(requestState) && connection?.counterpartyId && <Link href={`/provider/message?userId=${connection.counterpartyId}&messageId=${connection.initialMessageId}`} onClick={onClose} className="mt-6 rounded-lg bg-[#354EF0] px-6 py-3 text-sm font-semibold text-white hover:bg-[#2840df]">Open Messages</Link>}<button type="button" onClick={onClose} className="mt-7 min-w-[180px] rounded-lg bg-[#354EF0] px-6 py-3 text-sm font-semibold text-white hover:bg-[#2840df]">Done</button></div> : <form onSubmit={submitRequest} className="px-6 py-6 sm:px-8"><p className="text-sm leading-6 text-[#5F5F5F]">Send a request to Alpha.MD and we will coordinate a direct introduction between you and the right representative.</p><div className="mt-5 flex items-start gap-3 rounded-xl border border-[#E3E6FA] bg-[#F8F9FF] p-4"><FiUsers className="mt-0.5 shrink-0 text-[#354EF0]" size={22} /><div className="min-w-0"><div className="truncate text-base font-semibold text-[#333333]">{productName}</div><div className="mt-0.5 truncate text-sm text-[#808080]">{manufacturer}</div></div></div><label className="mt-5 block text-sm font-semibold text-[#3F3F3F]" htmlFor="rep-request-message">Note for our team <span className="font-normal text-[#929292]">(optional)</span></label><textarea id="rep-request-message" value={message} onChange={event_2 => setMessage(event_2.target.value.slice(0, 1000))} rows={4} placeholder="Tell us what you would like to discuss with the representative." className="mt-2 w-full resize-none rounded-lg border border-[#DDDDDD] px-3 py-2.5 text-sm text-[#444444] outline-none focus:border-[#354EF0] focus:ring-2 focus:ring-[#354EF0]/10" /><div className="mt-1 flex justify-between gap-3 text-xs text-[#929292]"><span>Do not include patient-identifiable information.</span><span>{message.length}/1000</span></div>{(error || statusError) && <div role="alert" className="mt-4 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{statusError || error}{isError && productId && <button type="button" onClick={refetch} disabled={checkingStatus} className="ml-2 font-semibold underline">Retry</button>}</div>}<div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end"><button type="button" onClick={onClose} disabled={isSubmitting} className="rounded-lg border border-[#D8D8D8] px-5 py-2.5 text-sm font-semibold text-[#606060] disabled:opacity-50">Cancel</button><button type="submit" disabled={isSubmitting || checkingStatus || Boolean(statusError)} className="rounded-lg bg-[#354EF0] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#2840df] disabled:cursor-not-allowed disabled:opacity-60">{isSubmitting ? "Sending request..." : checkingStatus ? "Checking request..." : "Request rep connection"}</button></div></form>;
    $[38] = checkingStatus;
    $[39] = connection;
    $[40] = error;
    $[41] = hasRequest;
    $[42] = isError;
    $[43] = isSubmitting;
    $[44] = manufacturer;
    $[45] = message;
    $[46] = onClose;
    $[47] = productId;
    $[48] = productName;
    $[49] = refetch;
    $[50] = requestState;
    $[51] = statusError;
    $[52] = submitRequest;
    $[53] = submittedRequest;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  let t19;
  if ($[55] !== t17 || $[56] !== t18) {
    t19 = <div className="w-full max-w-[640px] max-h-[calc(100vh-48px)] overflow-y-auto rounded-2xl bg-white shadow-2xl">{t17}{t18}</div>;
    $[55] = t17;
    $[56] = t18;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  let t20;
  if ($[58] !== t13 || $[59] !== t19) {
    t20 = createPortal(<div className="fixed inset-0 popup-bg z-[9999] flex items-center justify-center px-4 py-6" onMouseDown={t13} role="presentation">{t19}</div>, document.body);
    $[58] = t13;
    $[59] = t19;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  return t20;
};
export default AlphaMdRepRequestPopup;